var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKoktacredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit_card_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3332 5.0026V15.0026C18.3332 15.4609 18.17 15.8533 17.8436 16.1797C17.5172 16.5061 17.1248 16.6693 16.6665 16.6693H3.33317C2.87484 16.6693 2.48248 16.5061 2.15609 16.1797C1.8297 15.8533 1.6665 15.4609 1.6665 15.0026V5.0026C1.6665 4.54427 1.8297 4.15191 2.15609 3.82552C2.48248 3.49913 2.87484 3.33594 3.33317 3.33594H16.6665C17.1248 3.33594 17.5172 3.49913 17.8436 3.82552C18.17 4.15191 18.3332 4.54427 18.3332 5.0026ZM3.33317 6.66927H16.6665V5.0026H3.33317V6.66927ZM3.33317 10.0026V15.0026H16.6665V10.0026H3.33317Z",
    fill: "#404040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoktacredit);
export default __webpack_public_path__ + "static/media/koktacredit.37ffba57e611dfd4af20dd46d0b34ae5.svg";
export { ForwardRef as ReactComponent };